import { render, staticRenderFns } from "./homeCard.vue?vue&type=template&id=97a36268"
import script from "./homeCard.vue?vue&type=script&lang=js"
export * from "./homeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports